import Path from "./path";


// TODO: fix error for road figure (left top corner position)
// TODO: Define proper type of a boundingClientRect
/**
 * Returns coordinates of the figure center transformed for the description window
 * @typedef {Arrow|Group|PointFeature|Polygon|Polyline|Rectangle|Text}   Figure
 * @typedef {{x: number, y: number}}                                     Point
 * @param  {Figure}   figure                     Source figure (json object, not immutable)
 * @param  {Number}   scale                      The current scale of the canvas
 * @param  {Number}   CANVAS_WIDTH               The constant value of the canvas width
 * @param  {Number}   CANVAS_HEIGHT              The constant value of the canvas height
 * @param  {Any}      canvasBoundingClientRect   The boundingClientRect of the canvas node
 * @return {Point}    Coordinates for a positioning of the Description window
 */
export function getCoordinatesForDescriptionWindow(
    figure,
    scale,
    CANVAS_WIDTH,
    CANVAS_HEIGHT,
    canvasBoundingClientRect,
) {
    let centerX = 0, centerY = 0;

    if (["c", "p"].includes(figure.tool.split("-")[0])) {
        const transformedPath = Path.transform(figure.points, 0, 0, scale, scale);
        let center = Path.getCenter(transformedPath);
        centerX = center.centerX;
        centerY = center.centerY;
        centerX += (
            canvasBoundingClientRect?.get.left
            + (figure.x + CANVAS_WIDTH / 2) * scale
        );
        centerY += (
            canvasBoundingClientRect?.get.top
            + (figure.y + CANVAS_HEIGHT / 2) * scale
        );
    } else if (figure.tool.split("-")[0] === "i") {
        centerX = (
            figure.x + CANVAS_WIDTH / 2 + 2 * figure.volume
        ) * scale + canvasBoundingClientRect?.get.left;
        centerY = (
            figure.y + CANVAS_WIDTH / 2 + 1.5 * figure.volume
        ) * scale + canvasBoundingClientRect?.get.top;
    }
    return {x: centerX, y: centerY};
}
